import type { DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

export const LightTalosTheme: DefaultTheme = mapLightTheme(lightColors, {
  name: 'LightDefault',
});
